import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Modal, Form, Input, Button, Divider, Select, DatePicker, Radio } from 'antd';
import { useQuery, useMutation } from 'react-query';
import rootApi from '@utils/baseAPI/WrapperApi';
import get from 'lodash/get';
import { showError, showSuccess } from '@components/notification';
import * as yup from 'yup';
import { apiAddUserOperator } from '@services/ManageUserOperator/UserOperatorServices';
const { Option } = Select;

export const role_options = [
  { label: 'Công nhân', value: 0 },
  { label: 'Kỹ sư', value: 1 },
  { label: 'Lãnh đạo', value: 2 },
  { label: 'Quản trị viên', value: 101915236 }
];

function RequestDialogModel({ open, onClose }) {
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      email: '',
      phoneNumber: '',
      confirmPassword: '',
      role: 1
    },
    validationSchema: yup.object({
      username: yup.string().required().label('Tên đăng nhập'),
      // email: yup.string().email('Email không hợp lệ').required('Email là bắt buộc').label('Email'),
      // phoneNumber: yup.string().required('Số điện thoại là bắt buộc').label('Số điện thoại'),
      password: yup
        .string()
        .required('Mật khẩu là bắt buộc')
        .min(8, 'Mật khẩu phải có ít nhất 8 ký tự')
        .matches(/[a-zA-Z]/, 'Mật khẩu phải chứa ít nhất một chữ cái')
        .matches(/[0-9]/, 'Mật khẩu phải chứa ít nhất một chữ số')
        .matches(/[@$!%*?&#]/, 'Mật khẩu phải chứa ít nhất một ký tự đặc biệt')
        .label('Mật khẩu'),
      confirmPassword: yup
        .string()
        .required('Nhập lại mật khẩu là bắt buộc')
        .oneOf([yup.ref('password'), null], 'Mật khẩu nhập lại không khớp')
        .label('Nhập lại mật khẩu')
    }),
    onSubmit: async (values) => {
      try {
        setIsLoading(true);
        const payload = {
          user_name: get(values, 'username'),
          password: get(values, 'password'),
          // confirm_password: get(values, 'confirmPassword'),
          // email: get(values, 'email'),
          // phone_number: get(values, 'phoneNumber'),
          role: get(values, 'role')
        };
        const res = await apiAddUserOperator(payload);
        onClose();
        showSuccess({ message: 'Tạo người dùng thành công' });
        formik.resetForm();
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    }
  });

  return (
    <div>
      <Modal
        title="Tạo mới người dùng"
        visible={open}
        onCancel={onClose}
        footer={[
          <Button key="back" style={{ height: '36px' }} onClick={onClose}>
            Hủy
          </Button>,
          <Button
            key="submit"
            style={{ backgroundColor: '#00904A', color: '#FFFF', height: '36px' }}
            loading={isLoading}
            onClick={formik.handleSubmit}>
            Tạo mới
          </Button>
        ]}>
        <Form layout="vertical">
          <Form.Item
            label={
              <span>
                Tên đăng nhập <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.username ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.username}>
            <Input
              name="username"
              value={formik.values.username}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item>
          {/* <Form.Item
            label={
              <span>
                Số điện thoại <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.phoneNumber ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.phoneNumber}>
            <Input
              name="phoneNumber"
              value={formik.values.phoneNumber}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Email <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.email ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.email}>
            <Input
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item> */}
          <Form.Item
            label={
              <span>
                Mật khẩu <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.password ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.password}>
            <Input.Password
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Nhập lại mật khẩu <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.confirmPassword ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.confirmPassword}>
            <Input.Password
              name="confirmPassword"
              value={formik.values.confirmPassword}
              onChange={formik.handleChange}
              style={{ height: '36px' }}
            />
          </Form.Item>
          <Form.Item
            label={
              <span>
                Quyền người dùng <span style={{ color: 'red' }}>*</span>
              </span>
            }
            validateStatus={formik.errors.role ? 'error' : ''}
            style={{ marginBottom: 10 }}
            help={formik.errors.role}>
            <Select
              name="role"
              value={formik.values.role}
              style={{ height: '36px' }}
              onChange={(value) => formik.setFieldValue('role', value)}>
              {role_options.map((option) => (
                <Option key={option.value} value={option.value}>
                  {option.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default RequestDialogModel;
